// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"44":"fb7d5399","708":"component---src-pages-404-js","936":"component---src-pages-index-js"}[chunkId] + "-" + {"44":"4939c2b8fbed314d72a6","708":"d175eaab63a9982c604e","936":"ac062632e1adc4bb8cd7"}[chunkId] + ".js";
};